import { render, staticRenderFns } from "./OtherIdsReadOnlyPanel.vue?vue&type=template&id=0dcb77da"
import script from "./OtherIdsReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./OtherIdsReadOnlyPanel.vue?vue&type=script&lang=js"
import style0 from "./OtherIdsReadOnlyPanel.vue?vue&type=style&index=0&id=0dcb77da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports